export default "__VITE_ASSET__BiLx8qW8__"